import { styled } from '@mui/material/styles';
import { forwardRef, useMemo } from 'react';

import Button, { ButtonProps } from '@mui/material/Button';

interface PrimaryButtonProps extends ButtonProps {
  buttonColor?: "primary-green" | "white" | "secondary" | "secondary-white" | "yellow" | "red" | "purple" | "blue" | "orange" | "secondary-orange";
}

//#facc15
const PrimaryButton = forwardRef<HTMLButtonElement, PrimaryButtonProps>(({ buttonColor = "primary-green", ...props }: PrimaryButtonProps, ref) => {
  const CustomButton = useMemo(() => styled(Button)({
    textTransform: 'none',
    backgroundColor:
      buttonColor === "primary-green" ? "#009C4E" :
        buttonColor === "white" ? "#FFFFFF" :
          buttonColor === "yellow" ? "#facc15" :
            buttonColor === "purple" ? "#9333ea" :
              buttonColor === "blue" ? "#3b82f6" :
                buttonColor === "secondary-orange" ? "#f97316" :
                  (buttonColor === "red" ? "#ef4444" : "transparent"),
    color:
      buttonColor === "primary-green" || buttonColor === "secondary-white" || buttonColor === "red" || buttonColor === "purple" || buttonColor === "blue" || buttonColor === "secondary-orange"
        ? "#FFFFFF"
        : buttonColor === "orange"
          ? "#f97316"
          : buttonColor === "yellow" ? "#000000" : "#009C4E",
    width: "100%",
    height: "36px",
    border: buttonColor === "secondary" || buttonColor === "secondary-white" || buttonColor === "orange" ? "2px solid" : "",
    borderColor: buttonColor === "secondary"
      ? "#009C4E"
      : buttonColor === "secondary-white"
        ? "#FFFFFF"
        : buttonColor === "orange"
          ? "#f97316" : ""
  }), [buttonColor]);

  return (
    <div>
      <CustomButton ref={ref} {...props} />
    </div>
  );
});

export default PrimaryButton;
